const { GET_ACTIVE_USERS, GET_CONVERSION, GET_MESSAGES_FROM_CUSTOMERS, GET_PROVIDERS, GET_OFFERS_CONVERTED, GET_OFFERS_TO_CUSTOMERS, GET_GMV } = require("./dashboard.constants");

export const getProviders = (callback) => ({type: GET_PROVIDERS, callback})
export const getActiveUsers = (callback) => ({type: GET_ACTIVE_USERS, callback})
export const getOffersToCustomers = (callback) => ({type: GET_OFFERS_TO_CUSTOMERS, callback})
export const getMessagesFromCustomers = (callback) => ({type: GET_MESSAGES_FROM_CUSTOMERS, callback})
export const getConversion = (callback) => ({type: GET_CONVERSION, callback})
export const getOffersConverted = (callback) => ({type: GET_OFFERS_CONVERTED, callback})
export const getGMV = (callback) => ({type: GET_GMV, callback})